"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureResponseMapper = void 0;
var FeatureResponseMapper = /** @class */ (function () {
    function FeatureResponseMapper(data) {
        this.localData = data;
    }
    FeatureResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return FeatureResponseMapper;
}());
exports.FeatureResponseMapper = FeatureResponseMapper;
//# sourceMappingURL=FeatureResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/FeatureResponseMapper.js
// module id = 758
// module chunks = 8